import Loadable from '@loadable/component';

const ProjectRolesTable = Loadable(async () => import('./components/project-roles-table/index.js'));
const UserRoleForm = Loadable(async () => import('./components/user-role-form/index.js'));

export default {
  '/roles': {
    components: { main: ProjectRolesTable },
    '/:roleId': {
      components: { main: UserRoleForm }
    },
    '/duplicate/:roleId': {
      components: { main: UserRoleForm }
    }
  }
};
